<template>
  <v-content>
    <v-container>
      <v-card>
        <v-card-title>
          <h3>
            Manage Order UID
            <span v-if="currentCounter !== null">(Current Count - {{currentCounter}})</span>
          </h3>
        </v-card-title>
        <v-card-text >
          <v-alert transition="scroll-y-transition" :dismissible="true" type="error" :value="error.status">
            {{error.message}}
          </v-alert>
          <v-alert transition="scroll-y-transition" :dismissible="true" type="success" :value="success.status">
            {{success.message}}
          </v-alert>
          <v-form @submit.prevent="save" class="text-center mx-auto" style="max-width: 60%">
            <v-text-field label="Order Series" color="accent" v-model="uid.series"></v-text-field>
            <v-text-field label="Counter Starts" type="number" color="accent" v-model="uid.start"></v-text-field>
            <v-text-field label="Counter Ends" type="number" color="accent" v-model="uid.ends"></v-text-field>
            <v-btn type="submit" :loading="processing" color="accent">Save</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      processing: false,
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
      currentCounter: null,
      uid: {
        series: null,
        start: null,
        ends: null,
      },
    };
  },
  methods: {
    async save() {
      this.success.status = false;
      this.error.status = false;
      this.processing = true;
      try {
        await this.firebase.firestore().collection('order-series').doc('order-series').set(this.uid);
        this.success.status = true;
        this.success.message = 'Updated Successfully';
        this.processing = false;
      } catch (error) {
        console.log(error);
        this.error.status = true;
        this.error.message = 'Unknown Error! Please try again later';
        this.processing = false;
      }
      // here we will save the data
      // console.log('here we have to save the order UID');
    },
    async getData() {
      try {
        const orderSeriesQuery = await this.firebase.firestore().collection('order-series').doc('order-series').get();
        const currentCounterQuery = await this.firebase.firestore().collection('order-series').doc('counter').get();
        this.uid.series = await orderSeriesQuery.get('series');
        this.uid.ends = await orderSeriesQuery.get('ends');
        this.uid.start = await orderSeriesQuery.get('start');
        this.currentCounter = await currentCounterQuery.get('counter');
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>
